'use strict';
// ----------------------------------------------------------- scroll spy 
const scrollSpy = document.querySelector('.scrollSpy__progress');
const documentHeight = document.documentElement.scrollHeight;
document.addEventListener('scroll', doScrollSpy);

function doScrollSpy () {
    const PositionScroll = document.documentElement.scrollTop;
    const percentScroll = Math.round( (PositionScroll / documentHeight)* 100 )  ;

    scrollSpy.style.setProperty('--scrollPercent', `${percentScroll}%`)
}


// wavesCreatio()

// ----------------------------------------------------------- waves


// function wavesCreatio(){
    

//     const svg = document.createElementNS("http://www.w3.org/2000/svg","svg");
//     const path = document.createElementNS("http://www.w3.org/2000/svg","path");
//     const frequency = Math.random() * 0.05 ;
//     const amplitude = Math.random() * 20 ;
//     const phase = Math.random() * 10 ;
//     const svgheight = 50;
//     const svgwidth = window.innerWidth;

//     let pathData =`M 0 ${svgheight/2}`

//     svg.setAttribute('width', svgwidth)
//     svg.setAttribute('height', svgheight)

//     for (let x=0; x<svgwidth; x++){
//         const y = amplitude*Math.sin(frequency * x + phase )+ svgheight/2;
//         pathData += `L ${x} ${y} `


//     }
//         pathData += `L ${svgwidth} ${svgheight} L 0 ${svgheight} Z`
//         const wavecontainer = document.querySelector('.concepts_finaux_1__container');  
//         path.setAttribute("d",pathData)
//         svg.appendChild(path)
//         wavecontainer.appendChild(svg)
//         path.setAttribute("fill","black")

// } https://www.youtube.com/watch?v=debPZs45m44 ------CREDIT


//reflexion__nav__element reflexion__nav__element--active


const buttons = document.querySelectorAll('.reflexion__btn');
const buttonPrevious = document.querySelector('.reflexion__previous');
const buttonNext = document.querySelector('.reflexion__next');

const Imgs = document.querySelector('.reflexion__img');


    buttonNext.addEventListener('click', changeImgNext);
    buttonPrevious.addEventListener('click',changeImgPrevious);



function changeImgNext (event) {
    const navActive = document.querySelector('.reflexion__nav__element--active');
    event.preventDefault()
    const activeImg  = document.querySelector('.reflexion__img--active');

    
    let next = activeImg.nextElementSibling;
    let nextNavActive = navActive.nextElementSibling;
    if (next){
        next.classList.add('reflexion__img--active')
        nextNavActive.classList.add('reflexion__nav__element--active')
    }else{
        let firstChildNav = navActive.parentElement.firstElementChild;
        firstChildNav.classList.add('reflexion__nav__element--active')
        let firstchild = activeImg.parentElement.firstElementChild;
        firstchild.classList.add('reflexion__img--active')
    }
    activeImg.classList.remove('reflexion__img--active')
    navActive.classList.remove('reflexion__nav__element--active')
}



function changeImgPrevious (event) {
    event.preventDefault()
    const activeImg  = document.querySelector('.reflexion__img--active');
    activeImg.classList.remove('reflexion__img--active')
    
    let previous = activeImg.previousElementSibling;
    let previousNavActive = navActive.nextElementSibling;
    if (previous){
        previousNavActive.add('reflexion__nav__element--active')
        previous.classList.add('reflexion__img--active')
    }else{
        let LastChildNav = navActive.parentElement.lastElementChild;
        LastChildNav.classList.add('reflexion__nav__element--active')
        let lastchild = activeImg.parentElement.lastElementChild;
        lastchild.classList.add('reflexion__img--active')
    }
}